import axios from "axios";
import { BACKEND_URL } from "../../util/BACKEND_URL";

export const FETCH_CMS = "FETCH_CMS";
export const FETCH_COMPONENTS = "FETCH_COMPONENTS";

export const fetchCms = (slug, populate, jwt) => {
  console.log("Fetching: " + slug);

  return async (dispatch) => {
    try {
      // make request
      var config = {
        method: "get",
        url: `${BACKEND_URL}/api/${slug}?${populate}`,
      };

      // set auth token if we have it
      if (jwt)
        config.headers = {
          Authorization: `Bearer ${jwt}`,
        };

      const response = await axios(config);

      //   dispatch action
      dispatch({
        type: FETCH_CMS,
        slug: slug,
        data: response.data.data,
      });
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  };
};
